import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeAuthModal,
  openAuthModal,
  selectAuth,
  switchAuthType,
} from "../store/authslice";

const useAuthFlow = () => {
  const dispatch = useDispatch();
  const { isOpen, authType } = useSelector(selectAuth);

  const triggerAuth = useCallback(
    (type) => {
      dispatch(openAuthModal(type));
    },
    [dispatch]
  );

  return {
    isOpen,
    authType,
    onClose: () => dispatch(closeAuthModal()),
    triggerAuth,
    switchAuth: (type) => dispatch(switchAuthType(type)),
  };
};

export default useAuthFlow;